import {
  Button,
  Grid,
  Paper,
  styled,
  TableContainer,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Backdrop,
  Stack,
  CircularProgress,
  Chip,
  Select,
  MenuItem,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MainCard from "../../components/Maincard";
import { useNavigate } from "react-router-dom";
import CustomSnackbar from "../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import DownloadIcon from "@mui/icons-material/Download";
import HeadingCard from "../../newTestPrep/newComponent/NewCardsComp/HeadingCard";
import SearchButton from "../../newTestPrep/newComponent/NewButtonComp/SearchButton";
import ClearButtonComp from "../../newTestPrep/newComponent/NewButtonComp/ResetButtonComp";
import CustomAutocompleteComp from "../../newTestPrep/newComponent/AutocompleteComp";
import StyledTableContainer from "../../newTestPrep/newComponent/TableContainer";
import CustomPopup from "../../components/CustomPopup";
import TaargetRevenueBreakdown from "./TaargetRevenueBreakdown";

import { useGetTokenOrLogout } from "../../utils/token";
import LoaderComp from "../../newTestPrep/newComponent/LoaderComp/Loader";
import MoreCardDetails from "../AllUserDashboards/popupComponent/MoreCardDetails";
import CustomTextFieldComp from "../../newTestPrep/newComponent/customTextFieldComp";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function AdvisorTargetRevenue() {
  const userRole = localStorage.getItem("userRole");
  const userId = localStorage.getItem("userId");
       const countryId  =localStorage.getItem("employeeCountry")
  const getTokenOrLogout = useGetTokenOrLogout();
  const navigate = useNavigate();
  const [branchList, setBranchList] = useState([]);
  const [advisorList, setAdvisorList] = useState([]);
  const [statusList, setStatusList] = useState([
    { id: 1, name: "Active" },
    { id: 0, name: "Inactive" },
  ]);
  const [status, setSatus] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [countryName, setCountryName] = useState(parseInt(countryId));
  const [advisorName, setAdvisorName] = useState([]);
  const [branchName, setBranchName] = useState([]);
  const [selectedYear, setSelectedYear] = useState({
    year: new Date().getFullYear(),
  });
  const [targetData, setTargetTData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedBranchId, setSelectedBranchId] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");
  const [allAdvisorList, setAllAdvisorList] = useState([]);
  const [openDetailsPopup, setOpenDetailsPopup] = useState(false);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [selectedHeader, setSelectedHeader] = useState(null);
  const [monthName, setMonthName] = useState(null);
  const [targetdetailsData, setTargetDetailsData] = useState([]);
  const [openCollectedPopup, setOpenCollectedPopup] = useState(false);
  const [collectedData, setCollectedData] = useState([]);
  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  useEffect(() => {
    fetch(`${API_ENDPOINT}country`)
      .then((response) => response.json())
      .then((data) => {
        const filteredCountry = data.filter(
          (i) => i.country_name === "India" || i.country_name === "Nepal"
        );
        setCountryList(filteredCountry);
      })
      .catch((error) => {
        console.error("Error fetching state:", error);
      });
  }, []);

  const handleChangeCountry = (e) => {
    setBranchName([]);
    setSelectedBranchId([]);
    setAllAdvisorList([]);
    setAdvisorName([]);
    setCountryName(e.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}branch/bycountry/${countryName}`
        );
        if (response.ok) {
          const data = await response.json();
          setBranchList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [countryName]);

  const allBranchList = [{ branch_name: "Select All" }, ...branchList];

  const handleBranchChange = (event, value) => {
    if (value.some((item) => item.branch_name === "Select All")) {
      setBranchName(branchList);
      setSelectedBranchId(branchList.map((i) => i.id));
    } else {
      setBranchName(value);
      setSelectedBranchId(value.map((i) => i.id));
    }
  };

  const allStatusList = [{ id: 2, name: "Both" }, ...statusList];
  const handleStatusChange = (e, value) => {
    if (value.some((item) => item.id === 2)) {
      const selectedIds = statusList.map((i) => i.id);
      setSatus(statusList);
      setSelectedStatus(selectedIds);
    } else {
      const selectedIds = value.map((i) => i.id);
      setSatus(value);
      setSelectedStatus(selectedIds);
    }
  };

  const handleSearchAdvisors = async (selectedStatus) => {
    const requestData = {
      status: selectedStatus,
      branch_id: selectedBranchId,
      country_id: countryName,
    };

    try {
      const response = await fetch(`${API_ENDPOINT}advisor/bystutus`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (response.ok) {
        const result = await response.json();
        // const reversedData = result.slice().reverse();
        setAdvisorList(result);
      } else {
        console.log("Server Error", "error");
        setAdvisorList([]);
      }
    } catch (error) {
      console.log("Server Error", "error");
      setAdvisorList([]);
    }
  };

  useEffect(() => {
    handleSearchAdvisors(selectedStatus);
  }, [selectedStatus, selectedBranchId, countryName]);

  useEffect(() => {
    const updatedList = [
      ...(advisorList.length > 1
        ? [
            {
              first_name:
                advisorName.length === advisorList.length
                  ? "Deselect All"
                  : "Select All",
            },
          ]
        : []),
      ...advisorList,
    ];
    setAllAdvisorList(updatedList);
  }, [advisorList, advisorName]);

  const handleUserChange = (event, value) => {
    if (value.some((item) => item.first_name === "Select All")) {
      // If "Select All" is selected, set all branches
      setAdvisorName(advisorList);
    } else if (value.some((option) => option.first_name === "Deselect All")) {
      setAdvisorName([]);
    } else {
      // If individual branches are selected, remove "Select All"
      setAdvisorName(value);
    }
  };

  // Select Advisor Automatic base on Branch
  useEffect(() => {
    if (!Array.isArray(advisorList)) {
      console.error("advisorList is not an array:", advisorList);
      return;
    }

    if (selectedBranchId.includes("all")) {
      setAdvisorName(advisorList);
    } else {
      const branchViseAdvisor = advisorList.filter((advisor) =>
        selectedBranchId.includes(advisor.branch_id)
      );
      setAdvisorName(branchViseAdvisor);
    }
  }, [selectedBranchId, advisorList]);

  const years = Array.from({ length: 5 }, (_, index) => ({
    year: new Date().getFullYear() - 3 + index,
  }));

  const allYearList = [{ year: "Select All" }, ...years];
  const handleselectedYear = async (value) => {
    setSelectedYear(value);
  };

  const handleSearchData = async (advisorName) => {
    const selectedAdvisor = advisorName.map((i) => i.user_id);
    setLoading(true);

    const requestData = {
      country_id: countryName,
      user_id: parseInt(userId),
      year: selectedYear?.year,
      report_for:
        userRole === "center_admin" && selectedAdvisor.includes("all")
          ? "all"
          : userRole === "center_admin" && !selectedAdvisor.includes("all")
          ? selectedAdvisor
          : null,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}advisor-rev-target/getyeartargetsandrevenuecollected`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        }
      );
     const result = await response.json();
      if (response.ok) {
   
     
        setTargetTData(result);
        setLoading(false);
      } else if (response.status === 404) {
        navigate("/page404");
      } else if (response.status === 401) {
        navigate("/page401");
      } else if (response.status === 403) {
        showSnackbar("Please select user", "error");
        setTargetTData([]);
        setLoading(false);
      } else if (response.status === 440) {
        navigate("/page440");
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");
        setTargetTData([]);
        setLoading(false);
      } else {
        navigate("/page500");
      }
    } catch (error) {
      navigate("/page500");
    }
  };

  useEffect(() => {
    handleSearchData([{ user_id: "all" }]);
  }, []);

  const handleclear = () => {
    setBranchName([]);
    setSelectedBranchId([]);
    setAdvisorName([]);
    setTargetTData([]);
    setSelectedYear(null);
    setSatus([]);
    setCountryName(101);

    setAdvisorList([]);
  };

  const determineStatus = (row, currentMonth, currentYear) => {
    if (!row) return "Not Given"; // Guard clause to handle missing row.

    // Case when the target revenue is equal to the collected revenue.
    if (row?.targetRevenue <= row?.collectedRevenue) {
      return "Achieved";
    }

    // Case when the target revenue is greater than the collected revenue for the current month.
    if (
      currentMonth === row?.month &&
      row?.targetRevenue > row?.collectedRevenue
    ) {
      return "In Progress";
    }

    // Case when no target revenue is provided.
    if (row?.targetRevenue === "No Target Found") {
      return "Not Given";
    }

    // If the year is the current year or in the future, determine if it's upcoming.
    if (row?.year >= currentYear) {
      if (row?.year === currentYear && currentMonth < row?.month) {
        return "Upcoming"; // Target in future months of the current year.
      }
      if (row?.year > currentYear) {
        return "Upcoming"; // Target in the future year.
      }
    }

    // If the year is before the current year or in the past, determine if it's incomplete.
    if (
      row?.year < currentYear ||
      (row?.year === currentYear && currentMonth > row?.month)
    ) {
      return "Incompleted"; // Target in the past and not completed.
    }

    return "Not Given"; // Default return for unhandled cases.
  };

  const getStatusChipProps = (status) => {
    switch (status) {
      case "Achieved":
        return { label: "Achieved", color: "secondary", variant: "contained" };
      case "Incompleted":
        return { label: "Incomplete", color: "error", variant: "contained" };
      case "In Progress":
        return { label: "In-Progress", color: "warning", variant: "contained" };
      case "Upcoming":
        return { label: "Upcoming", color: "primary", variant: "contained" };
      case "Not Given":
        return { label: "Not Given", color: "default", variant: "contained" };
      default:
        return { label: "Not Given", color: "default", variant: "contained" };
    }
  };

  const handleViewReport = () => {
    const url = `/advisor-target-report-pdf`;
    window.open(url, "_blank");

    const targetDataObject = {
      targetData,
      advisorName,
      selectedYear,
      countryName
    };
    localStorage.setItem("targetdata", JSON.stringify(targetDataObject));
  };

  const handleViewtestReport = () => {
    const url = `/test-type-wise-revenue`;
    window.open(url, "_blank");
  };

  // Target BreakDown
  const handleOpenPopup = (monthName, filterFor, headerName) => {
    setOpenDetailsPopup(true);
    setSelectedHeader(headerName);
    setMonthName(monthName);
  };

  const handleClosePopup = () => {
    setOpenDetailsPopup(false);
  };

  const handleSearchTargetsData = async (monthName, filterFor, headerName) => {
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };

    const requestData = {
      user_id: parseInt(userId),
      year: selectedYear?.year,
 report_for: advisorName.length >0 ?  advisorName.map((i) => i.user_id) :"all",
    
      month: monthName,
      filter_for: filterFor,
       country_id :countryName
    };

    setDetailsLoading(true);
    try {
      const response = await fetch(
        `${API_ENDPOINT}advisor-rev-target/getyeartargetsandrevenuecollected-with-detail`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

              const result = await response.json();
      if (response.ok) {


        setTargetDetailsData(result);
        setDetailsLoading(false);
        handleOpenPopup(monthName, filterFor, headerName);
      } else if (response.status === 401) {
        showSnackbar("Unknown User", "error");
        setDetailsLoading(false);
      } else if (response.status === 403) {
        showSnackbar("Unathorized User", "error");

        setDetailsLoading(false);
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");

        setDetailsLoading(false);
      }
      
      else {
        showSnackbar("Server Error", "error");
        setDetailsLoading(false);
      }
    } catch (error) {
      showSnackbar("Server Error", "error");
        setDetailsLoading(false);
    }
  };

  // Collectde Breakdown

  const handleOpenCollectedPopup = (monthName, filterFor, headerName) => {
    setOpenCollectedPopup(true);
    setSelectedHeader(headerName);
    setMonthName(monthName);
  };

  const handleCloseCollectedPopup = () => {
    setOpenCollectedPopup(false);
  };



  const handleSearchCampaignData = async (monthName, filterFor, headerName) => {
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };

    const requestData = {
      user_id: parseInt(userId),
      year: selectedYear?.year,
      report_for: userRole==="advisor" ? [parseInt(userId)] : advisorName.length>0 ? advisorName.map((i) => i.user_id) :"all",
      month: monthName,
      filter_for: filterFor,
      country_id :countryName
    };

    setDetailsLoading(true);
    try {
      const response = await fetch(
        `${API_ENDPOINT}advisor-rev-target/getyeartargetsandrevenuecollected-with-detail`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        const result = await response.json();

        setCollectedData(result);
        setDetailsLoading(false);
        handleOpenCollectedPopup(monthName, filterFor, headerName);
      } else if (response.status === 401) {
        showSnackbar("Unknown User", "error");
        setDetailsLoading(false);
      } else if (response.status === 403) {
        showSnackbar("Unathorized User", "error");

        setDetailsLoading(false);
      } else {
        showSnackbar("Server Error", "error");
        setDetailsLoading(false);
      }
    } catch (error) {}
  };
  return (
    <>
      <LoaderComp isLoading={detailsLoading} />
      <Backdrop open={loading} style={{ zIndex: 9999 }}>
        <Stack direction="row" spacing={1}>
          <Typography
            variant="h4"
            color="secondary"
            fontWeight={800}
            marginRight={2}
          >
            Fetching
          </Typography>
          <CircularProgress color="primary" />
        </Stack>
      </Backdrop>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={5} md={3} lg={2}>
          <HeadingCard
            label={
              userRole === "center_admin" ? "Advisor's Target" : "Your Target"
            }
          />
        </Grid>
        {userRole === "center_admin" && (
          <Grid item xs={12} sm={7} md={9} lg={10} textAlign="end">
            <Button
              size="small"
              variant="contained"
              color="secondary"
              style={{ borderRadius: "25px" }}
              startIcon={<DownloadIcon />}
              onClick={handleViewReport}
            >
              Download Report
            </Button>
          </Grid>
        )}

        {(["advisor", "team_lead"].includes(userRole))&& (
          <Grid item xs={12} sm={7} md={9} lg={10} textAlign="end">
            <Button
              size="small"
              color="secondary"
              variant="contained"
              style={{ borderRadius: "25px" }}
              onClick={handleViewtestReport}
            >
              View Test Wise Revenue Report
            </Button>
          </Grid>
        )}
        <Grid item xs={12}>
          <MainCard>
            <Grid container spacing={2}>
              {userRole === "center_admin" && (
                <>
                  <Grid item xs={12} sm={4} md={3}>
                    <Typography variant="h6">Select Country</Typography>
                    <CustomTextFieldComp
                      size="normal"
                      select
                      value={countryName}
                      onChange={handleChangeCountry}
                      fullWidth
                      InputProps={{ style: { borderRadius: "10px" } }}
                    >
                      {countryList?.map((country) => (
                        <MenuItem key={country.id} value={country.id}>
                          {country.country_name}
                        </MenuItem>
                      ))}
                    </CustomTextFieldComp>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="h6">Select Branch</Typography>
                    <CustomAutocompleteComp
                      size="small"
                      value={branchName}
                      multiple
                      onChange={handleBranchChange}
                      options={allBranchList}
                      getOptionLabel={(option) => option.branch_name}
                      tooltipContent={(option) => option.branch_name}
                      placeholder="Please Select Branches"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          InputProps={{
                            ...params.InputProps,
                            style: { borderRadius: "14px" }, // Add borderRadius here
                          }}
                        />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      renderOption={(props, option, { selected }) => (
                        <li
                          {...props}
                          style={{
                            backgroundColor: selected ? "#e0f7fa" : "inherit",
                          }}
                        >
                          {option.branch_name}
                        </li>
                      )}
                    />
                  </Grid>

                  {/* <Grid item xs={12} sm={3}>
                    <Typography>Select Advisor</Typography>
                    <CustomAutocompleteComp
                      size="small"
                      value={advisorName}
                      multiple
                      onChange={handleUserChange}
                      options={allAdvisorList}
                      getOptionLabel={(option) =>
                        `${option.first_name ? option.first_name : ""} ${
                          option.last_name ? option.last_name : ""
                        }`
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          InputProps={{
                            ...params.InputProps,
                            style: { borderRadius: "14px" }, // Add borderRadius here
                          }}
                        />
                      )}
                    />
                  </Grid> */}
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="h6">Select Advisor Status</Typography>
                    <CustomAutocompleteComp
                      multiple
                      value={status}
                      onChange={handleStatusChange}
                      size="small"
                      options={allStatusList}
                      getOptionLabel={(option) => option.name}
                      tooltipContent={(option) => option.name}
                        placeholder="Please Select Status"
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="h6">Select Advisor</Typography>
                    <CustomAutocompleteComp
                      size="small"
                      value={advisorName}
                      multiple
                      noOptionsText={
                        status.length > 0
                          ? allAdvisorList.length === 0
                            ? "No Advisor Available"
                            : ""
                          : "Please Select Advisor Status First"
                      }
                      onChange={handleUserChange}
                      options={allAdvisorList}
                      getOptionLabel={(option) =>
                        `${option.first_name ? option.first_name : ""} ${
                          option.last_name ? option.last_name : ""
                        }`
                      }
                      tooltipContent={(option) =>
                        `${option.first_name ? option.first_name : ""} ${
                          option.last_name ? option.last_name : ""
                        }`
                      }
                        placeholder="Please Select Advisor"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          InputProps={{
                            ...params.InputProps,
                            style: { borderRadius: "14px" }, // Add borderRadius here
                          }}
                        />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option.user_id === value.user_id
                      }
                      renderOption={(props, option, { selected }) => {
                        return (
                          <li
                            {...props}
                            style={{
                              backgroundColor: selected ? "#e0f7fa" : "inherit",
                            }}
                          >
                            {option.first_name} {option.last_name}
                          </li>
                        );
                      }}
                    />
                  </Grid>
                </>
              )}
              <Grid item xs={12} sm={6} md={3}>
                <Typography variant="h6">Select Year</Typography>
                <CustomAutocompleteComp
                  value={selectedYear}
                  onChange={(event, value) => handleselectedYear(value)}
                  size="small"
                  options={years}
                  getOptionLabel={(option) => option.year}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                        style: { borderRadius: "15px" }, // Add borderRadius here
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <Typography variant="h6" visibility="hidden">
                  Spacing Purpose
                </Typography>
                <Grid container gap={1}>
                  <SearchButton
                    size="small"
                    showIcon={true}
                    onClick={() => handleSearchData(advisorName)}
                  />

                  <ClearButtonComp size="small" onClick={handleclear} />
                </Grid>
              </Grid>
            </Grid>
          </MainCard>
        </Grid>

        <Grid item xs={12}>
          <MainCard>
            <StyledTableContainer component={Paper} borderLeft={true}>
              <Table
                sx={{ minWidth: 650, tableLayout: "fixed" }}
                aria-label="simple table"
                stickyHeader
              >
                <TableHead>
                  <TableRow>
                    <TableCell>Month</TableCell>
                    <TableCell>Currency</TableCell>
                    <TableCell sx={{}}>Target</TableCell>
                    <TableCell sx={{}}>Collected</TableCell>
                    <TableCell>Achieved Percentage</TableCell>
                    <TableCell sx={{}}>Status</TableCell>
                  </TableRow>
                </TableHead>

                {targetData?.length === 0 ? (
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="h5">No data available</Typography>
                  </Grid>
                ) : (
                  targetData?.map((row, index) => {
                    const currentDate = new Date();
                    const currentMonth = currentDate.getMonth() + 1;
                    const currentYear = currentDate.getFullYear();

                    // let status = "";
                    // if (
                    //   currentMonth === row?.month &&
                    //   row?.targetRevenue > row?.collectedRevenue
                    // ) {
                    //   status = "In Process";
                    // } else if (
                    //   currentMonth > row?.month &&
                    //   row?.targetRevenue > row?.collectedRevenue
                    // ) {
                    //   status = "Incompleted";
                    // } else if (row?.targetRevenue === row?.collectedRevenue) {
                    //   status = "Completed";
                    // }
                    // if (row?.year === currentYear + 1) {
                    //   status = "Upcomming";
                    // } else {
                    //   status = "Not Given";
                    // }
                    const status = determineStatus(
                      row,
                      currentMonth,
                      currentYear
                    );

                    return (
                      <TableBody>
                        <TableRow
                          key={row.name}
                          style={{
                            backgroundColor:
                              index % 2 === 0 ? "#f0f0f0" : "inherit",
                          }}
                        >
                          <TableCell sx={{ borderLeft: "0.1px solid #C3C3C3" }}>
                            {row?.monthName}
                          </TableCell>
                          <TableCell>{row?.currency}</TableCell>
                          <TableCell
                            style={{
                              cursor: "pointer",
                              color:
                                row.targetRevenue === "No Target Found"
                                  ? "inherit"
                                  : "blue",
                            }}
                            onClick={() =>
                              handleSearchTargetsData(
                                row?.monthName,
                                "target_revenue",
                                "Target Revenue"
                              )
                            }
                          >
                            {row.targetRevenue === "No Target Found"
                              ? "N/A"
                              : `${row?.targetRevenue}`}{" "}
                          </TableCell>
                          <TableCell
                            style={{
                              cursor: "pointer",
                              color: "blue",
                            }}
                            onClick={() =>
                              handleSearchCampaignData(
                                row?.monthName,
                                "collected_revenue",
                                "Collected Revenue"
                              )
                            }
                          >
                            {row?.collectedRevenue}{" "}
                          </TableCell>

                          <TableCell>
                            {row?.percentageAchieved !== "N/A"
                              ? `${row?.percentageAchieved} %`
                              : row?.percentageAchieved}
                          </TableCell>
                          <TableCell
                            sx={{ borderRight: "0.1px solid #C3C3C3" }}
                          >
                            {" "}
                            <Chip
                              size="small"
                              variant="contained"
                              {...getStatusChipProps(status)}
                            />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    );
                  })
                )}
              </Table>
            </StyledTableContainer>
          </MainCard>
        </Grid>
      </Grid>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />

      <CustomPopup
        open={openDetailsPopup}
        onClose={handleClosePopup}
        title={`${selectedHeader} Details`}
        component={
          <TaargetRevenueBreakdown
            onClose={handleClosePopup}
            selectedYear={selectedYear?.year}
            monthName={monthName}
            detailsData={targetdetailsData}
            countryId={countryName}
          />
        }
        maxWidth="sm"
        showDivider={true}
      />

      <CustomPopup
        open={openCollectedPopup}
        onClose={handleCloseCollectedPopup}
        title={`${selectedHeader} Details`}
        component={
          <MoreCardDetails
            onClose={handleCloseCollectedPopup}
            selectedYear={selectedYear?.year}
            monthName={monthName}
            SelectedCardData={collectedData}
            selectedFilter="default"
            countryId={countryName}

            // selectedCardName={selectedCardName}
            // selectedCountFilter={selectedcardFilter}
          />
        }
        maxWidth="lg"
        showDivider={true}
      />
    </>
  );
}
